export const getPreviousPage = (pathname) => {
  const getSlicedPageIndex = (pathname) => pathname.lastIndexOf('/');
  const previousPage = getSlicedPageIndex(pathname) === pathname.length - 1
    ? pathname.slice(0, getSlicedPageIndex(pathname.slice(0, -1)))
    : pathname.slice(0, getSlicedPageIndex(pathname));

  return `${previousPage}/`;
};
